import { type IconType } from "..";

const HomeIcon: IconType = (props) => {
  const fill = props.fill ?? "fill-white";

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 25.9 25.2"
      className={`${props.size}`}
      {...props}
    >
      <path
        className={`${fill}`}
        d="M12.6 19.5h.8V18c0-.1.1-.3.3-.3h1.5v-.8h-1.5c-.1 0-.3-.1-.3-.3v-1.5h-.8v1.5c0 .1-.1.3-.3.3h-1.5v.8h1.5c.1 0 .3.1.3.3v1.5Zm1 .6h-1.3c-.1 0-.3-.1-.3-.3v-1.5h-1.5c-.1 0-.3-.1-.3-.3v-1.3c0-.1.1-.3.3-.3H12v-1.5c0-.1.1-.3.3-.3h1.3c.1 0 .3.1.3.3v1.5h1.5c.1 0 .3.1.3.3V18c0 .1-.1.3-.3.3h-1.5v1.5c0 .1-.1.3-.3.3"
      />
      <path
        className={`${fill}`}
        d="M3.9 24.1h18.2V10.2H3.9v13.9Zm18.6.8H3.4c-.2 0-.4-.2-.4-.4V9.8c0-.2.2-.4.4-.4h19c.2 0 .4.2.4.4v14.7c0 .2-.2.4-.4.4"
      />
      <path
        className={`${fill}`}
        d="M1.9 9.4h22l-11-8.2-11 8.2Zm23.3.8H.7c-.2 0-.3-.1-.4-.3s0-.4.2-.5L12.7.3c.1-.1.4-.1.5 0l12.3 9.1c.1.1.2.3.1.5 0 .2-.2.3-.4.3M10.3 12.4c-1.6 0-3 1.5-3 3.3v.3c0 .3 0 .6.2.9.5 1.5 1.8 3.6 5.4 5.4 3.6-1.8 4.9-3.9 5.4-5.4.1-.3.2-.6.2-.9v-.3c0-1.8-1.3-3.3-3-3.3s-1.7.4-2.3 1.2c-.2.2-.5.2-.7 0-.6-.7-1.4-1.2-2.3-1.2m2.7 10.8h-.2c-4-1.9-5.5-4.3-6-6-.1-.4-.2-.7-.2-1.1v-.4c0-2.2 1.7-4.1 3.8-4.1s1.9.4 2.6 1.1c.7-.7 1.6-1.1 2.6-1.1 2.1 0 3.8 1.8 3.8 4.1v.3c0 .4-.1.7-.2 1.1-.5 1.7-2 4.1-6 6h-.2"
      />
      <path
        className={`${fill}`}
        d="M19.5 6H6.3c-.2 0-.4-.2-.4-.4s.2-.4.4-.4h13.2c.2 0 .4.2.4.4s-.2.4-.4.4"
      />
      <path
        className={`${fill}`}
        d="M20.5 6.6c-.2 0-.4-.2-.4-.4V2.9h-2.2v1.2c0 .2-.2.4-.4.4s-.4-.2-.4-.4V2.5c0-.2.2-.4.4-.4h3c.2 0 .4.2.4.4v3.8c0 .2-.2.4-.4.4"
      />
    </svg>
  );
};

export default HomeIcon;
